import React, { ReactNode, useRef } from 'react'
import { useReactToPrint } from 'react-to-print'
import { format } from 'date-fns'

interface Props {
	buttonText?: string
	children: ReactNode
}

export default function PrintWrapper({ buttonText, children }: Props) {
	const componentRef = useRef(null)
	const handlePrint = useReactToPrint({
		content: () => componentRef.current,
		pageStyle: ''
	})

	return (
		<div ref={componentRef}>
			<div className="flex justify-center">
				<img src="/images/themes/theme-chart-header.jpeg" alt="arc logo" className="hidden print:block" />
			</div>

			{buttonText ? (
				<button onClick={handlePrint} className="mb-2 flex justify-end gap-3 text-slate-400 print:hidden">
					<span>{buttonText}</span>
					<svg xmlns="http://www.w3.org/2000/svg" className="z-50 h-6 w-6" viewBox="0 0 20 20" fill="currentColor">
						<path
							fillRule="evenodd"
							d="M5 4v3H4a2 2 0 00-2 2v3a2 2 0 002 2h1v2a2 2 0 002 2h6a2 2 0 002-2v-2h1a2 2 0 002-2V9a2 2 0 00-2-2h-1V4a2 2 0 00-2-2H7a2 2 0 00-2 2zm8 0H7v3h6V4zm0 8H7v4h6v-4z"
							clipRule="evenodd"
						/>
					</svg>
				</button>
			) : (
				<div className="mb-2 flex justify-end gap-3 text-slate-400 print:hidden">
					<button onClick={handlePrint}>
						<svg xmlns="http://www.w3.org/2000/svg" className="z-50 h-6 w-6" viewBox="0 0 20 20" fill="currentColor">
							<path
								fillRule="evenodd"
								d="M5 4v3H4a2 2 0 00-2 2v3a2 2 0 002 2h1v2a2 2 0 002 2h6a2 2 0 002-2v-2h1a2 2 0 002-2V9a2 2 0 00-2-2h-1V4a2 2 0 00-2-2H7a2 2 0 00-2 2zm8 0H7v3h6V4zm0 8H7v4h6v-4z"
								clipRule="evenodd"
							/>
						</svg>
					</button>
				</div>
			)}
			{children}
			<div className="hidden bg-white print:block">
				<span className="block text-center font-semibold">
					ARC Core implementations are strengthened by these recommended components, services, and materials; some of which may require an additional fee.
				</span>
			</div>
			<div className="hidden justify-center print:block">
				<img src="/images/themes/theme-chart-footer.jpeg" alt="leveling bar footer" />
			</div>
			<div className="mb-8 hidden justify-center print:flex">
				<span className="block pl-4 font-bold text-ar-100">
					NOTE: If you are experiencing issues with colors not appearing on the chart, please enable the "Print backgrounds" option in this print window.
				</span>
			</div>
			<div className="mb-3 hidden justify-center print:flex">
				<span className="text-2xl text-slate-800">Printed {format(new Date(), 'MMMM do, yyyy')}</span>
			</div>
		</div>
	)
}
